import { Button, Stack, TextArea } from '@servicetitan/design-system';
import { useState } from 'react';
import styles from './MessageInputFooter.module.css';
import { useEventListener } from 'usehooks-ts';

interface MessageInputFooterProps {
  onSendMessage: (message: string) => void;
}

const MessageInputFooter = ({ onSendMessage }: MessageInputFooterProps) => {
  const [message, setMessage] = useState('');

  const handleSendMessage = () => {
    onSendMessage(message);
    setMessage('');
  };

  useEventListener('keydown', (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      message !== '' && handleSendMessage();
    }
  });

  return (
    <div className={`p-x-3 p-y-2 ${styles.footerTopBorder}`}>
      <Stack spacing={2} alignItems='flex-end'>
        <TextArea
          placeholder='Type your message'
          value={message}
          className={styles.messageTextArea}
          autoHeight
          maxRows={5}
          rows={1}
          onChange={(e) => setMessage(e.target.value)}
        />
        <div>
          <Button
            color='primary'
            iconName='send'
            disabled={!message}
            onClick={handleSendMessage}
          />
        </div>
      </Stack>
    </div>
  );
};

export default MessageInputFooter;
